export const formatDate = (date: string | Date): string => {
  const dateArray = new Date(date).toDateString().split(' ');
  return dateArray[2] + '/' + dateArray[1] + '/' + dateArray[3];
};

export const formatDateWithTime = (date: string | Date): string => {
  const newDate = new Date(date);
  const dateArray = newDate.toDateString().split(' ');
  const time = newDate.toTimeString().split(' ')[0];

  return `${dateArray[2]}/${dateArray[1]}/${dateArray[3]} ${time}`;
};

export const getTimeString = (
  date: string | Date,
  minutesToAdd: number = null
) => {
  const newDate = new Date(date);
  if (minutesToAdd !== null) {
    newDate.setMinutes(newDate.getMinutes() + minutesToAdd);
  }
  return newDate.toTimeString().split(' ')[0];
};

export const currentTimeString = (
  withSeconds = true,
  secondsToAdd: number = null
) => {
  const newDate = new Date();
  if (secondsToAdd !== null) {
    newDate.setSeconds(newDate.getSeconds() + secondsToAdd);
  }

  const time = newDate.toTimeString().split(' ')[0];
  let hrs = newDate.getHours();

  hrs = (hrs + 24 - 2) % 24;
  let mid = 'am';
  if (hrs === 0) {
    //At 00 hours we need to show 12 am
    hrs = 12;
  } else if (hrs > 12) {
    mid = 'pm';
  }

  if (withSeconds) {
    return `${time} ${mid}`;
  }

  const timeArr = time.split(':');
  return `${timeArr[0]}:${timeArr[1]} ${mid}`;
};
